var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('link',{attrs:{"href":"https://fonts.googleapis.com/css?family=Material+Icons","rel":"stylesheet"}}),(_vm.ready)?_c('v-main',[_c('router-view',{key:_vm.$route.fullPath}),_c('snackbar')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }